// Progress status copy for the driver tracking flow. 5 discrete states,
// advanced one at a time via the bottom CTA. Kept separate so the
// orchestrator and the hero pill share the same source of truth.

export const bookingProgressStatusList = [
  "Aucun",
  "En route",
  "Sur place",
  "Passagers à bord",
  "Mission cloturée",
];

export const bookingProgressStatusActionList = [
  "Je suis en route",
  "Je suis sur place",
  "Les passagers sont à bord",
  "Passagers déposés",
  "Mission cloturée",
];
